import { ListItemText } from '@mui/material'
import React from 'react'
import { Link as RouterLink, useLocation } from 'react-router'
import { NavigatorButton, NavigatorIcon } from './styles'

type NavigatorItemProps = {
  title: string
  icon: React.ReactElement
  to: string
  pattern: RegExp
  onClick: () => void
}

const NavigatorItem = (props: NavigatorItemProps) => {
  const { title, icon, to, pattern, onClick } = props
  const location = useLocation()
  const isActive = !!location.pathname.match(pattern)

  const hasScheme = to.includes('http')

  return (
    <NavigatorButton
      component={hasScheme ? 'a' : RouterLink}
      to={to}
      href={to}
      target={hasScheme ? '_blank' : '_self'}
      sx={isActive ? { color: '#4fc3f7' } : {}}
      onClick={onClick}>
      <NavigatorIcon>{icon}</NavigatorIcon>
      <ListItemText sx={{ fontSize: 'inherit' }}>{title}</ListItemText>
    </NavigatorButton>
  )
}

export default NavigatorItem
